module.exports = __webpack_public_path__ + "static/img/4.00eb71b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting790/images/4.png
// module id = zEzh
// module chunks = 4